import { render, staticRenderFns } from "./OlderDetailFeeChoose.vue?vue&type=template&id=51f066a7&scoped=true"
import script from "./OlderDetailFeeChoose.vue?vue&type=script&lang=js"
export * from "./OlderDetailFeeChoose.vue?vue&type=script&lang=js"
import style0 from "./OlderDetailFeeChoose.vue?vue&type=style&index=0&id=51f066a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f066a7",
  null
  
)

export default component.exports